let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fDZtj")).then(() => parcelRequire('iza1d'));